import React, {Component} from 'react'
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import Constants from "../../utils/constants";
import PatientSelectComponent from "../single_components/PatientSelectComponent";
import Error from "../single_components/Error";
import AlertConfirm from "../modals/Confirm";
import SvGraphics from "../../assets/SvGraphics";
import Select from "react-select";
import {authenticationService} from "../../services/AuthenticationService";
import {OverlayTrigger} from "react-bootstrap";
import Popover from "react-bootstrap/Popover";

class LeumitSelfOtherMedicalInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,

        }
    }

    componentDidMount() {
        let {t} = this.props

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }



    render() {
        let {t} = this.props
        let {entry} = this.state
        let currentUser = authenticationService.currentUserValue;
        let language = localStorage.getItem('language')

        return (
            <div className={'patientsFormBoxes'}>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <div className='flex-Display'>
                                <label className={'infoLabel-withError'}>{t('patient_boarding.Psychiatric_diagnosis')}?*</label>
                                <Error errorClass={'error-message-label-flex'} isShown={!!(this.props.errors)['Psychiatric_diagnosis']}
                                       errorMessage={(this.props.errors)['Psychiatric_diagnosis']}/>
                            </div>
                        </div>
                        <div className={'inputBoxStyle-yes-no-block'}>

                        <button tabIndex={0}  className={entry.Psychiatric_diagnosis==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("Psychiatric_diagnosis","Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Psychiatric_diagnosis==="No"? 'inputBoxStyle-yes-no-middle-selected' :'inputBoxStyle-yes-no-middle'}
                                onClick={(event) => this.props.onYesNoValueChange("Psychiatric_diagnosis","No")}>{t('patient_boarding.no')}</button>
                        <button tabIndex={0} className={entry.Psychiatric_diagnosis==="Unknown"?  'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("Psychiatric_diagnosis","Unknown")}>{t('patient_boarding.Unknown')}</button>
                    </div>
                    </div>
                </div>

                <div className={'patientsFormRow'}>

                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <div className='flex-Display'>
                                <label className={'infoLabel-withError'}>{t('patient_boarding.Nuclear_family_psychosis')}?*</label>
                                <Error errorClass={'error-message-label-flex'} isShown={!!(this.props.errors)['Nuclear_family_psychosis']}
                                       errorMessage={(this.props.errors)['Nuclear_family_psychosis']}/>
                            </div>
                        </div>
                        <div className={'inputBoxStyle-yes-no-block'}>

                        <button tabIndex={0}  className={entry.Nuclear_family_psychosis==="Yes"?'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("Nuclear_family_psychosis", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Nuclear_family_psychosis==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("Nuclear_family_psychosis", "No")}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                    </div>


                </div>


                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <div className='flex-Display'>
                                <label className={'infoLabel-withError'}>{t('patient_boarding.Drug_abuse')}?*</label>
                                <Error errorClass={'error-message-label-flex'} isShown={!!(this.props.errors)['Drug_abuse']}
                                       errorMessage={(this.props.errors)['Drug_abuse']}/>
                            </div>
                        </div>
                        <div className={'inputBoxStyle-yes-no-block'}>

                        <button tabIndex={0}  className={entry.Drug_abuse==="Yes"?  'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("Drug_abuse", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Drug_abuse==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("Drug_abuse", "No")}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                    </div>
                </div>
        <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <div className='flex-Display'>
                                <label className={'infoLabel-withError'}>{t('patient_self_boarding.SuffersDiabetes')}*</label>
                                <Error errorClass={'error-message-label-flex'} isShown={!!(this.props.errors)['SuffersDiabetes']}
                                       errorMessage={(this.props.errors)['SuffersDiabetes']}/>
                            </div>
                        </div>
                        <div className={'inputBoxStyle-yes-no-block'}>

                        <button tabIndex={0}  className={entry.SuffersDiabetes==="Yes"?  'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("SuffersDiabetes", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.SuffersDiabetes==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("SuffersDiabetes", "No")}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                    </div>
                </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <div className='flex-Display'>
                                <label className={'infoLabel-withError'}>{t('patient_self_boarding.SuffersBloodPressure')}*</label>
                                <Error errorClass={'error-message-label-flex'} isShown={!!(this.props.errors)['SuffersBloodPressure']}
                                       errorMessage={(this.props.errors)['SuffersBloodPressure']}/>
                            </div>
                        </div>
                        <div className={'inputBoxStyle-yes-no-block'}>

                        <button tabIndex={0}  className={entry.SuffersBloodPressure==="Yes"?  'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("SuffersBloodPressure", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.SuffersBloodPressure==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("SuffersBloodPressure", "No")}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                    </div>
                </div>





                {this.props.docWidth<1200 && <div className={'patientsFormRow'}>
                    <div className={'next-Tab-Container'} onClick={()=>this.props.changeTabInternalView(3)}> {t('patient_self_boarding.continue_uploadFiles')}</div>
                </div>}

            </div>

        )
    }
}

LeumitSelfOtherMedicalInfo.propTypes = {
    onValueChange: PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default LeumitSelfOtherMedicalInfo;
